export const Environments = {
  LOCAL: 'local',
  STAGE: 'stage',
  PROD: 'prod',
}
